import { useMemo } from 'react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { SMSNumberV1 } from '@frontend/api-sms-number';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';

export type UseCareCreditSmsNumberProps = {
  person: Person | undefined;
  locationId: string | undefined;
  preferredPhoneNumber?: string;
};
export const useCareCreditSmsNumber = ({ person, locationId, preferredPhoneNumber }: UseCareCreditSmsNumberProps) => {
  const { validPhones, isLoading } = SMSNumberV1.Hooks.usePersonSMSNumbersValidity({
    personId: person?.personId ?? '',
    person,
    groupIds: locationId ? [locationId] : [],
    defaultToValid: false,
  });

  const firstValidPhoneNumber = useMemo(() => {
    if (preferredPhoneNumber !== undefined) {
      return validPhones.find(
        ({ number }) => formatPhoneNumberE164(number) === formatPhoneNumberE164(preferredPhoneNumber)
      )?.number;
    }

    return validPhones[0]?.number;
  }, [preferredPhoneNumber, validPhones]);

  return {
    firstValidPhoneNumber,
    isLoading,
  };
};
